<template>
  <div v-if="showPopup" class="popup-overlay">
    <div class="popup-content">
      <button class="close-btn" @click="closePopup">×</button>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSd0VG53Nol7xKMl2eF5UW_ZGhPT_KEZyoFalkjROJNMI8GN1g/viewform?usp=dialog"
        target="_blank">
        <img src="@/assets/images/consulta-publica.jpeg" alt="Consulta Publica" class="popup-image" />
      </a>
    </div>
  </div>
</template>


<script>
export default {
  name: "PopupDiario",
  data() {
    return {
      showPopup: true,
    };
  },
  methods: {
    closePopup() {
      this.showPopup = false;
    },
  },
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
}

.popup-content {
  position: relative;
  background: white;
  border-radius: 8px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-image {
  width: 400px;
  height: 500px;
  object-fit: cover;
  border-radius: 8px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  font-size: 24px;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: self-end;
}
</style>
